export default __webpack_public_path__ + "c0e1f84bf3225bce71829e83eaf0baa4.png";